import React, { memo } from "react";

interface IProps {
  size?: number;
}

const ShieldAttachIcon: React.FC<IProps> = memo(({ size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.64 15.76L11.3 13.44L9.54 15.2L8.98 14.64C8.67333 14.3333 8.52 13.9533 8.52 13.5C8.52 13.0467 8.67333 12.6667 8.98 12.36L12.36 8.98C12.6667 8.67333 13.0467 8.52 13.5 8.52C13.9533 8.52 14.3333 8.67333 14.64 8.98L15.2 9.54L13.44 11.3L15.76 13.64C15.92 13.8 16 13.9867 16 14.2C16 14.4133 15.92 14.6 15.76 14.76L14.76 15.76C14.6 15.92 14.4133 16 14.2 16C13.9867 16 13.8 15.92 13.64 15.76ZM16 3.2L6.92 12.28L7.02 12.36C7.32667 12.6667 7.48 13.0467 7.48 13.5C7.48 13.9533 7.32667 14.3333 7.02 14.64L6.46 15.2L4.7 13.44L2.36 15.76C2.2 15.92 2.01333 16 1.8 16C1.58667 16 1.4 15.92 1.24 15.76L0.24 14.76C0.08 14.6 0 14.4133 0 14.2C0 13.9867 0.08 13.8 0.24 13.64L2.56 11.3L0.8 9.54L1.36 8.98C1.66667 8.67333 2.04667 8.52 2.5 8.52C2.95333 8.52 3.33333 8.67333 3.64 8.98L3.72 9.08L12.8 0H16V3.2ZM3.96 7.16L0 3.2V0H3.2L7.16 3.96L3.96 7.16Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { ShieldAttachIcon };
